import $console from "@zuto/utilities/src/$console"
import MarketingHelper from '@zuto-internal/zuto-marketing-helper'
import ZutoAnalyticsHelper from '@zuto-internal/zuto-analytics-helper'

const zutoAnalyticsHelper = new ZutoAnalyticsHelper()

type eventProps = {
  eventType: string,
  questionName: string,
  deviceId: string,
  sessionId: string,
  experimentName: string
}

export const sendFormAbandonmentEvent = ({ eventType, questionName, deviceId, sessionId, experimentName }: eventProps) => {
  try {
    const attribution = MarketingHelper.getChannelAttribution()

    zutoAnalyticsHelper.sendCustomEventAsync({
      eventType,
      eventCategory: 'Form Abandonment',
      eventAction: questionName,
      conversationalAppForm: false,
      device: deviceId,
      session: sessionId,
      source: attribution.source ?? 'Direct',
      eventSource: attribution.source ?? 'Direct',
      medium: attribution?.medium ?? 'NoAttribution',
      campaign: attribution?.campaign ?? 'Zuto',
      experiment: experimentName
    })
  } catch (e) {
    $console.error('zutoAnalyticsHelper.sendCustomEvent error', e)
  }
}